import { CreateSiteType } from "./apiBodyTypes"
import { makeGetRequest, makePostRequest } from "./restServices"

async function creatSite(body: CreateSiteType): Promise<{ success: boolean, data?: {}, err?: any }> {
    try {
        const res = await makePostRequest("/site/creat-site", body)
        if (!res.data.success)
            throw new Error("error")
        return { success: true, data: {} }

    } catch (err: any) {
        console.log("err", err)
        return { success: false, err: err?.response?.data.message || "Login Failed" }
    }
}
async function updateSite(body: CreateSiteType): Promise<{ success: boolean, data?: {}, err?: any }> {
    try {
        const res = await makePostRequest("/site/update-site", body)
        if (!res.data.success)
            throw new Error("error")
        return { success: true, data: {} }

    } catch (err: any) {
        console.log("err", err)
        return { success: false, err: err?.response?.data.message || "Login Failed" }
    }
}
async function fetchAllSites(sortKey: string, sortOrder: string, search: string, filters: string[]) {
    try {
        const response = await makePostRequest("site/get-all-sites", {
            sortKey,
            sortOrder,
            search,
            filters,
        });
        if (response.data.success) {
            return response.data.data;
        }
        throw new Error("Failed to fetch sites");
    } catch (error) {
        console.error("Error in getAllSites:", error);
        return [];
    }
}

async function getAllSites() {
    try {
        const user = await makeGetRequest("site/get-all-sites-names")
        if (user.data.success)
            return user.data.data
    }
    catch (err) {
        console.log("err", err)
        return { success: false, data: {} }
    }
}
async function fetchSiteAdmins() {
    try {
        const res = await makeGetRequest("site/fetch-site-admins")
        if (res.data.success) {
            return res.data.data;
        }
        else {
            return { success: false, data: { errorMessage: res.data.errorMessage } };
        }
    } catch (err: any) {
        console.error("Error fetching site admins:", err);
        return { success: false, data: { errorMessage: err?.response?.data.message || "error fetching site admins" } };
    }
}
export { creatSite, updateSite, fetchAllSites, getAllSites, fetchSiteAdmins }